<template>
  <div class="app">
    <nav class="navbar is-light is-fixed-top">
      <div class="bd-special-shadow" />
      <div class="container">
        <div class="navbar-brand">
          <router-link
            :to="{ name: 'home' }"
            class="navbar-item"
          >
            <img
              src="static/kithara.svg"
              alt="Kithara"
              width="112"
              height="28"
            >
          </router-link>
          <div
            class="navbar-burger burger"
            :class="{ 'is-active': navbarShown }"
            @click="toggleNavbar()"
          >
            <span />
            <span />
            <span />
          </div>
        </div>

        <div
          class="navbar-menu"
          :class="{ 'is-active': navbarShown }"
        >
          <div class="navbar-start">
            <router-link
              :to="{ name: 'home' }"
              class="navbar-item"
              @click.native="toggleNavbar(false)"
            >
              Home
            </router-link>
            <router-link
              :to="{ name: 'table' }"
              class="navbar-item"
              @click.native="toggleNavbar(false)"
            >
              Table
            </router-link>
            <router-link
              :to="{ name: 'playlists' }"
              class="navbar-item"
              @click.native="toggleNavbar(false)"
            >
              Playlists
            </router-link>
          </div>
          <div class="navbar-end">
            <div class="navbar-item">
              <div class="field is-grouped is-grouped-multiline">
                <p class="control">
                  <a
                    class="button is-info"
                    @click="download()"
                  >
                    <span>Export</span>
                  </a>
                  <a
                    class="button"
                    @click="logout()"
                  >
                    <span>Logout</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <router-view
      class="router-view"
      @click.native="toggleNavbar(false)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      navbarShown: false
    };
  },
  methods: {
    toggleNavbar(value = null) {
      this.navbarShown = value === null ? !this.navbarShown : value;
    },
    download() {
      this.$store.dispatch("download").then(() => this.toggleNavbar(false));
    },
    logout() {
      this.$store.dispatch("logout").then(() => this.$router.push("/login"));
    }
  }
};
</script>

<style lang="scss">
.bd-special-shadow {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), transparent);
  height: 8px;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  opacity: 1;
  transform: scaleY(1);
  transform-origin: center top;
}
</style>



// WEBPACK FOOTER //
// Home.vue?6fd406f5